'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';

export const mobileTabFooterVisibilityAtom = atom<boolean>(true) as WritableAtom<
  boolean,
  [boolean],
  void
>;

export const setMobileTabFooterVisibilityAtom = atom(null, (get, set, visible: boolean) => {
  set(mobileTabFooterVisibilityAtom, visible);
});

export function useMobileTabFooterVisibility() {
  const [visible] = useAtom(mobileTabFooterVisibilityAtom);
  const setVisibility = useSetAtom(setMobileTabFooterVisibilityAtom);

  return {
    isMobileTabFooterVisible: visible,
    setMobileTabFooterVisibility: (value: boolean) => setVisibility(value),
  };
}
